import Routes from "./routes";
import "./styles/globals.scss";

function App() {
  return <Routes />;
}

export default App;
